"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _findNearest = _interopRequireDefault(require("../utils/findNearest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useTownStationFromGPS = _ref => {
  let {
    gpsPosition,
    stationStops
  } = _ref;
  const [stationTownObj, setStationTownObj] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(gpsPosition) && !(0, _isEmpty.default)(stationStops)) {
      var _copy$sort;
      const {
        lat: posLat,
        lng: posLng
      } = gpsPosition;
      const copy = JSON.parse(JSON.stringify(stationStops));
      copy === null || copy === void 0 || copy.forEach(station => {
        const {
          latitudeStart,
          longitudeStart
        } = station;
        station.distanceInKm = (0, _findNearest.default)(latitudeStart, longitudeStart, posLat, posLng);
      });
      const nearestStation = (_copy$sort = copy.sort((a, b) => a.distanceInKm - b.distanceInKm)) === null || _copy$sort === void 0 ? void 0 : _copy$sort[0];
      const {
        id,
        city,
        pagename,
        title
      } = nearestStation || {};
      if (city && title) {
        setStationTownObj({
          id,
          pagename,
          station: title,
          town: city
        });
      }
    }
  }, [gpsPosition, stationStops]);
  return stationTownObj;
};
var _default = exports.default = useTownStationFromGPS;